import React, {Component, h } from "preact";
import {AppPage} from "../../_common/components/app-page";
import { Form as FinalForm} from 'react-final-form'
import {FormField, FormFieldSplittedDate, SubmitButtonRow} from "../../_common/forms/components/components";
import {connect} from "react-redux";
import {fetchStudent, saveStudent} from "../../_rx/student/actions";
import {Card, CF, E, FR, R} from "../../_common/layout";
import {t} from '../../_i18n';
import {Redirect} from "react-router";
import {ButtonLink, ButtonPrimary} from "../../_common/components/buttons/buttons";


let BirthDateView = class extends Component {

    componentDidMount() {
        const {auth} = this.props;
        this.props.fetchStudent(auth.loggedUser.id);
    }

    onSubmit(data){
        return this.props.saveStudent(data).catch(err=> ({'error': true}));
    }

    handleCancel(e){
        e.preventDefault()
        this.props.history.goBack()
    }

    render({student, history}) {
        return student &&
            <CF className="max-width m-top-header-xs-sm">
                <Card className="p-bottom">
                <h1>{t('update_birth_date')}</h1>
                <FinalForm onSubmit={data=>this.onSubmit(data)} initialValues={student} render = {
                    ({handleSubmit,  submitting, errors, pristine, submitSucceeded})=>
                    <form className='form' action="" onSubmit={handleSubmit} noValidate>
                        {submitSucceeded && history.goBack()}
                        <h2 className="m-top m-bottom">{t('Fecha nacimiento')}</h2>
                        <R>
                            <div className="col-100 md-col-60">
                                <FormFieldSplittedDate name="data.birth_date" required={true} />
                            </div>
                        </R>
                        <SubmitButtonRow disabled={submitting} onCancel={(e) => this.handleCancel(e)} />                     
                    </form>
                }
                />
                </Card></CF>;
    }
};


BirthDateView = connect(
    ({auth, student}) => ({auth, student}),
    {
        fetchStudent,
        saveStudent
    })(BirthDateView);

const BirthDate = ({history}) =>
    <AppPage
        name="birthdate"
        className="max-width"
    >
        <BirthDateView history={history}/>
    </AppPage>
;

export default BirthDate;
